export default (state = true, { type, payload }) => {
  switch (type) {
    case 'LANDTRUST_API_LOADING_ON':
      return true
    case 'LANDTRUST_API_LOADING_OFF':
      return false
    case 'LOGOUT':
      return false
    default:
      return state
  }
}